"use client";

import { useState, useEffect } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export function SearchBar({
  value,
  onChange,
  placeholder = "Rechercher...",
  debounce = 300,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounce?: number;
}) {
  const [localValue, setLocalValue] = useState(value);

  // Sync si le parent change la valeur (ex: reset)
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  // Debounce : appeler onChange après un délai
  useEffect(() => {
    if (localValue === value) return;
    const timer = setTimeout(() => onChange(localValue), debounce);
    return () => clearTimeout(timer);
  }, [localValue, debounce]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        placeholder={placeholder}
        className="pl-9"
      />
    </div>
  );
}
